export enum NpsSurveyTabType {
  SETUP = 'setup',
  DASHBOARD = 'dashboard',
}
